/*
**  rui-tag-button.js
**
**  rui-tag-button component
*/
import { LitElement, html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
export class RuiTagButton extends LitElement {
    static get is() {
        return 'rui-tag-button';
    }
    static get properties() {
        return {
            text: { type: String },
            isClickable: { type: Object },
            isClosable: { type: Object }
        };
    }
    constructor() {
        super();
        this.text = '';
        this.isClickable = false;
        this.isClosable = false;
    }
    click(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.isClickable) {
            let clickEvent = new CustomEvent('rui-click', {
                detail: this.text,
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(clickEvent);
        }
    }
    render() {
        const classes = {
            ['rui-tag-button']: true,
            ['rui-tag-button-non-clickable']: !this.isClickable
        };
        return html `
            <button type="button" class="${classMap(classes)}" @click="${this.click}" ?disabled="${!this.isClickable}">
                <span>${this.text}</span>
                ${this.isClosable ? html `<rui-icon iconType="close" context="tag-close-btn" class="rui-tag-close-icon"></rui-icon>` : ''}
            </button>
        `;
    }
    static get styles() {
        return css `
            .rui-tag-close-icon {
                margin-left: 10px;
            }
            
            .rui-tag-button {
                background-color: var(--rui-btn-misc-bg, #d7e8f9);
                border: none;
                border-radius: var(--rui-btn-border-radius, 16px);
                color: var(--rui-text-regular, #09175b);
                cursor: pointer;
                font-family: var(--rui-font-family, "Noto Sans", Roboto, Arial, -apple-system, system-ui, sans-serif);
                font-size: 12px;
                font-weight: var(--rui-btn-font-weight, 500);
                line-height: var(--rui-btn-line-height-md, 1.42857143);
                padding: 4px 11px;
                margin: 0 5px 7px 0;
                min-height: 27px;
                transition: background 0.25s;
                user-select: none;
            }

            @media (prefers-reduced-motion: reduce) {
                .rui-tag-button {
                    transition: none;
                }
            }

            .rui-tag-button:not(:disabled):hover {
                background-color: var(--rui-btn-misc-bg-hover, #b8d6f4);
            }
            
            .rui-tag-button:not(:disabled):focus {
                background-color: var(--rui-btn-misc-bg-hover, #b8d6f4);
                outline: var(--rui-outline-width, 1px) var(--rui-outline-style, solid) var(--rui-btn-primary-border, #085ce5);
                outline-offset: var(--rui-outline-offset-btn, 0);
            }
            
            .rui-tag-button:not(:disabled):active {
                background-color: var(--rui-btn-misc-bg-hover, #b8d6f4);
                outline: var(--rui-outline-width, 1px) var(--rui-outline-style, solid) var(--rui-btn-primary-border, #085ce5);
                outline-offset: var(--rui-outline-offset-btn, 0);
            }
            
            .rui-tag-button-non-clickable:disabled {
                background-color: var(--rui-content-secondary-bg, #eaecf1);
                cursor: default;
                user-select: text;
            }

            @media print {
                .rui-tag-button {
                    background-color: transparent;
                    border: 1px solid #000000;
                    color: #000000;
                }

                .rui-tag-button-non-clickable:disabled {
                    background-color: #eeeeee;
                    border: none;
                    color: #000000;
                }    
            }
        `;
    }
}
RuiTagButton.shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };
customElements.get(RuiTagButton.is) || customElements.define(RuiTagButton.is, RuiTagButton);
